<template>
    <div style="padding-bottom: 15px;">
        <p class="little-label">在已有未到期<span style="color:#9B0000;">付费</span>账号上增加选配授权。</p>
        <div class="step_item">
            第①步：验证未到期账号
        </div>
        <div class="step_content" v-show='showTips != "success"'>
            账号<input type="text" v-model='user' />&nbsp;请输入密码进行验证<input type="password" v-model='usernumber'> 
            <NormalButton style='height:26px;width:55px;' :disabled='$route.name == "Preview" ?  true : false' class="blue_btn" @click='send'>去验证</NormalButton>
            <a class="forget_pwd" target="_blank" :href="forgetPwdUrl">找回账号密码</a>
        </div>
        <div class="line-dot">
            <div class="tips" v-show='showTips == "success"'>
                <h5><i class="success-icon"></i>账号 {{user}} 验证成功！<b @click='back' class='back'>继续对其它账号加购</b></h5>
                <p v-show="hasOld">本次选配授权，只收取自今日起至账号{{user}}到期日期间相应费用（不足一个月，按一个月计），选配授权到期日同此账号到期日：<span class='date'>{{limitDate}}</span>。</p>
            </div>
            <div class="tips" v-show='showTips == "fail"'>
                <h5><i class="fail-icon"></i>验证失败</h5>
                <p>{{errMsg}}</p>
            </div>
        </div>
        <div class="step_item" style="margin-bottom:15px;">
            第②步：选配{{(isWH10 || isWH11)? "数据":"授权"}}
        </div>
        <AuthChoose :authConfigData='authConfigData' ref='choosen'/>
        <p class="little-label" v-show='authNames != ""'>加购授权：{{authNames}}</p>

    </div>
</template>

<script>
import wh from '../../assets/js/wh'
    const triggerOnce = wh.triggerOnce()
    export default {
        name: 'add-buy',
        components: {
            
        },
        inject: ['changeMainPrice','addValidCross','orderByMonth', 'setAddBuyValidState', 'getPwdAddress'],
        provide() {
            let self = this
            return {
                selectAuthItem(x) {
                    self.selectData = JSON.parse(JSON.stringify(x))
                    self.authNames = x.map(v=>v.name || v.productName).join('+')
                },
                fatherType () {
                    return 'add'
                }
            }
        },
        props: {
            data: Array
        },
        data: () => ({
            showTips: '',
            user: '',
            usernumber: '',
            limitDate: '2020年12月07日',
            authConfigData: null,
            authNames: '',
            selectData: [],
            errMsg: '',
            isOrderByMonth: false,
            hasOld: false
        }),
        computed:{
            hasMajor () {
                let flag = -1
                this.selectData.forEach(v=>{
                    if (v.cmajor === 1 && v.productlink && v.productlink.indexOf('EUREX') < 0 && v.productName.indexOf('香港') < 0) {
                        flag = 1
                    } else if (v.cmajor === 0 && v.productlink && v.productlink.indexOf('EUREX') < 0 && v.productName.indexOf('香港') < 0) {
                        flag = 0
                    }
                })
                return flag
            },
            hasOgz () {
                let flag = -1
                this.selectData.forEach(v=>{
                    if (v.cmajor === 1 && v.productlink && (v.productlink.indexOf('EUREX') >= 0 || v.productName.indexOf('香港') >= 0)) {
                        flag = 1
                    } else if (v.cmajor === 0 && v.productlink && (v.productlink.indexOf('EUREX') >= 0 || v.productName.indexOf('香港') >= 0)) {
                        flag = 0
                    }
                })
                return flag
            },
            hasOut () {
                let flag = false
                this.selectData.forEach(v=>{
                    if (v.grouptype == 1 || v.grouptype == 2 || v.grouptype == 3 || v.grouptype == 4) {
                        flag = true
                    }
                })
                return flag
            },
            selectIds () {
                return this.selectData.map(v=>v.id).join(',')
            },
            forgetPwdUrl () {
                var url = this.getPwdAddress && this.getPwdAddress()
                if (url) {
                    return url
                } else if (this.$route.params.id == 76) {
                    url = 'https://www.wenhua.com.cn/home/whsforgot?client=wh7'
                } else if (this.$route.params.id == 1) {
                    url = 'https://www.wenhua.com.cn/home/whsforgot?client=wh8'
                } else if (this.$route.params.id == 124) {
                    url = 'https://www.wenhua.com.cn/home/whsforgot?client=wh9'
                } else if (this.$route.params.id == 125 || this.$route.params.id == 138) {
                    url = 'https://webapi.wenhua.com.cn/AutoRegister/ForgetPwd'
                } else if (this.$route.params.id == 126) {
                    url = 'https://webapi.wenhua.com.cn/AutoRegister/ForgetPwdWh5'
                } else if (this.$route.params.id == 129) {
                    url = 'https://webapi.wenhua.com.cn/AutoRegister/ForgetPwdWh5'
                } else if (this.$route.params.id == 128) {
                    url = 'https://webapi.wenhua.com.cn/AutoRegister/ForgetPwdWh5'
                }
                return url
            },
            hasHistoryData () {
                return this.$refs.choosen.hasHistoryData
            },
            isWH10 () {
                return ['110','125', '126', '128', '129', '138'].includes(this.$route.params.id)
            },
            isWH11 () {
                return ['131'].includes(this.$route.params.id)
            }
        },
        watch: {
            data: {
                handler (val) {
                   this.authConfigData = [val[1]]
                },
                immediate:true
            }
        },
        mounted() {
            this.changeMainPrice && this.changeMainPrice(0)
            this.setAddBuyValidState && this.setAddBuyValidState(this.back)
        },
        methods: {
            send (finish) {
                var self = this
                if (/^[A-Z]+$/.test(this.user)) {
                    finish()
                    return this.$market.alert({content: '账号不能包含大写字母!'})
                } else if (this.user == '') {
                    this.$market.alert({content:'付费账号不能为空！'})
                    return finish()
                }
                if (this.usernumber == '') {
                    this.$market.alert({content:'请输入密码。'})
                    return finish()
                }
                
                this.$axios({
                    url: "/api/Wh5Order/Wh5AccountAdd?pid=129&account=" + this.user + "&identityType=3&pwd=" + this.usernumber,
                    method: "get"
                })
                .then(res => {
                    if(res.data && res.data.status) {
                        if (res.data.accountType == 1) {
                            finish()
                            return this.$market.alert({content: ' 月/季账号不能加购授权！'})
                        }
                        if (this.$route.name !== 'single_addbuy') {
                            this.$store.commit('addbuy/setCompanyID', res.data.companyId)
                        } else {
                            this.$store.commit('addbuy/setCompanyID', this.$route.query.companyid || -1)
                        }
                        
                        if (res.data.companyId == 1) {
                            finish()
                            return this.$market.alert({
                                content: '验证失败！',
                                btnTxt: '确认',
                                confirmCall: () =>{
                                    // this.$router.push({
                                    //     path: '/single/addbuy/'+this.$route.params.id,
                                    //     query: {
                                    //         companyid: res.data.companyId
                                    //     }
                                    // })
                                }
                            })
                        }
                        self.$store.commit('addbuy/setUserInfo',{ //记录用户名密码和加密串
                            user: self.user,
                            password: self.usernumber,
                            fetchData: res
                        })
                        self.showTips = 'success'// 显示提示
                        self.limitDate = res.data.etime
                        
                        let oldright = res.data.oldright.split(',').filter(v=>v!='') //获取已经购买过的授权
                        if (oldright.length > 0) {
                            this.hasOld = true
                        }
                        this.$axios({
                            url: '/api/Product/Detail?id=' + res.data.data.id + '&usercode=' + res.data.userCode
                        }).then(res => {
                            this.addValidCross && this.addValidCross(true)
                            let _configue = res.data.data.sublist ? res.data.data.sublist.filter(v=>v.grouptype == -1) : []
                            let _authorizan = res.data.data.sublist ? res.data.data.sublist.filter(v=>v.grouptype != -1) : []

                            this.authConfigData = []

                            // this.authConfigData = _configue.map(v => ({
                            //     name: v.productName,
                            //     price: v.price,
                            //     id: v.id,
                            //     link: v.link,
                            //     disable: true,
                            //     bought: false
                            // }))
                            let add_require = []
                            if (_authorizan.filter(v => v.isout == 1).length > 0) {
                                add_require.push({
                                    name: '境外实时数据',
                                    sublist: _authorizan.filter(v => v.isout == 1 && v.grouptype != 7 && v.grouptype != 8).map(v=>({...v,cdisable: false})),//※※此处为数据的源头，必须要再数据源头上加上，后面组件需要的数据字段（cdisable等），后续特殊场景中修改这些字段时，才会被响应
                                    disable: true,
                                    bought: false
                                }) 
                            }
                            this.authConfigData = [...this.authConfigData, ...add_require]
                            //遍历授权项数据，把已经买过的授权项禁用
                            this.authConfigData.forEach(item=>{
                                if (item.id && oldright.find(v=>v==item.id)) { //查询第一级目录，如果是已经购买的授权项怎禁用改项
                                    item.disable = true
                                    item.bought = true
                                } else {
                                    item.disable = false
                                    item.sublist && item.sublist.forEach(auth=>{ //有第二级目录，则查询第二级目录
                                        if (auth.id && oldright.find(v=>v==auth.id)) { //如果已经购买过，则禁用该项，并需要禁用同属于该项的排斥项
                                            auth.cdisable = true
                                            item.sublist.filter(v=>(v.isMutex == auth.isMutex && auth.isMutex != 0)).forEach(v=>{
                                                v.cdisable = true
                                            })
                                        }
                                    })
                                }
                            })
                            finish()
                        })

                    } else {
                        finish()
                        self.showTips = 'fail'// 显示失败提示
                        self.limitDate = ''
                        this.authConfigData.forEach(item=>{
                            item.disable = true
                        })
                        self.errMsg = res.data.message
                    }
                }).catch(e=>{
                    finish()
                });
            },
            back () {
                this.addValidCross && this.addValidCross(false)
                this.showTips = ''
                this.user = ''
                this.usernumber = ''
                this.hasOld = false
                this.authConfigData = [...this.authConfigData.map(v => ({
                    ...v,
                    disable: true,
                    bought: false
                }))]
            }
        }
    }
</script>

<style scoped>
    .little-label{
        font-size: 12px;
        color: rgb(111, 111, 113);
        clear: both;
        padding: 5px 0 4px;
        margin: 0;
    }
    
    .line-dot {
        border-bottom: 1px dashed rgb(136, 137, 138);
        clear: both;
        padding-top: 10px;
        margin-bottom: 10px;
    }
    .choose_item{
        float: left;
    }
    .step_item{
        font-size: 14px;
        color: rgb(6, 96, 172);
    }
    .step_content{
        color: rgb(111, 111, 113);
        font-size: 14px;
        margin-top: 10px;
    }
    .step_content input {
        width: 90px;
        background:white;
        border: 1px solid rgb(192, 192, 192);
        height: 25px;
        line-height: 22px;
        border-radius: 2px;
        margin: 0 4px;
        outline: none;
        padding-left: 10px;
    }
    .forget_pwd {
        color:rgb(6, 96, 172);
        font-size: 12px;
        margin-left: 5px;
        position: relative;
        top: 5px;
    }
    .blue_btn {
        background: rgb(6, 96, 172);
        color: white;
        font-size: 12px;
        border: 0;
        border-radius: 3px;
        padding: 5px 10px;
        outline: 0;
    }
    .tips {
        background: rgb(255, 245, 233);
        color: rgb(129, 91, 36);
        padding: 10px;
    }
    .tips h5 {
        padding: 0;
        margin: 0;
        margin-bottom: 5px;
        font-size: 13px;
    }
    .tips p{
        margin: 0;
    }
    .tips p .date {
        color: rgb(253, 98, 43);
        font-size: 14px;
    }
    .tips h5.success {
        padding-left: 20px;
    }
    .success-icon{
        width: 20px;
        height: 11px;
        display: inline-block;
        background: url(../../assets/image/duicuo.png) no-repeat left center;
    }
    .tips h5 .back {
        padding-left: 20px;
        float:right;
        background: url(../../assets/image/fanhui.png) no-repeat left center;
        color: rgb(60, 141, 237);
        text-decoration: underline;
        border: 0;
        cursor: pointer;
        outline: none;
        font-weight: normal;
    }
    .fail-icon{
        width: 20px;
        height: 11px;
        display: inline-block;
        background: url(../../assets/image/duicuo.png) no-repeat -25px center;
    }
</style>